export const OFFICIAL_PRODUCT_URL = 'https://www.specialized.com/tw/zh/s-works-tarmac-sl9-ltd-built-for-legends/p/4296507?color=5474191-4296507'

export const PRICE = 'NT$448,000'

export const FRAME_SIZES = ['44', '49', '52', '54', '56', '58'] as const

export type FrameSize = typeof FRAME_SIZES[number]

export type BikeImageKey = 'profile' | 'frontQuarter' | 'rearQuarter' | 'seatTube' | 'cockpit' | 'headTube'

export type BikeImage = {
    src: string
    width: number
    height: number
    studio: boolean
}

// Cutouts (studio: false) have transparent backgrounds. Studio shots sit on a light grey sweep.
export const BIKE_IMAGES: Record<BikeImageKey, BikeImage> = {
    profile: { src: '/images/hero-profile.webp', width: 2400, height: 1350, studio: false },
    frontQuarter: { src: '/images/front-quarter.webp', width: 2400, height: 1350, studio: false },
    rearQuarter: { src: '/images/rear-quarter.webp', width: 2400, height: 1350, studio: false },
    seatTube: { src: '/images/detail-seat-tube.webp', width: 2400, height: 1350, studio: false },
    cockpit: { src: '/images/detail-cockpit.jpg', width: 1280, height: 1280, studio: true },
    headTube: { src: '/images/detail-head-tube.jpg', width: 1280, height: 1280, studio: true }
}

export const GALLERY_ORDER: Array<BikeImageKey> = ['profile', 'frontQuarter', 'rearQuarter', 'seatTube', 'cockpit', 'headTube']

// Frame geometry per size, in the same order as FRAME_SIZES. Lengths in mm, angles in degrees.
export const GEOMETRY = {
    stack: [501, 514, 527, 544, 565, 591],
    reach: [366, 375, 380, 384, 395, 402],
    headTubeLength: [99, 109, 120, 140, 157, 184],
    headTubeAngle: [70.5, 71.75, 72.5, 72.5, 73.5, 73.5],
    seatTubeAngle: [75.5, 75.5, 74, 74, 73.5, 73.5],
    topTube: [496, 509, 531, 540, 563, 577],
    chainstay: [410, 410, 410, 410, 410, 410],
    bbDrop: [74, 74, 74, 72, 72, 72],
    wheelbase: [970, 973, 975, 986, 991, 1006],
    forkOffset: [47, 47, 47, 47, 44, 44],
    trail: [71, 63, 58, 58, 55, 55],
    standover: [722, 734, 745, 767, 785, 807]
} as const

export type GeometryKey = keyof typeof GEOMETRY

export const GEOMETRY_ORDER: Array<GeometryKey> = [
    'stack',
    'reach',
    'headTubeLength',
    'headTubeAngle',
    'seatTubeAngle',
    'topTube',
    'chainstay',
    'bbDrop',
    'wheelbase',
    'forkOffset',
    'trail',
    'standover'
]

export const GEOMETRY_ANGLES: Array<GeometryKey> = ['headTubeAngle', 'seatTubeAngle']

// Specialized race simulation of a 100 km Grand Tour stage, size 56, all bikes on SRAM RED AXS.
export const STAGE_SIMULATION = [
    { id: 'tarmac-sl9', name: 'Tarmac SL9', gap: 0, time: '2:43:44' },
    { id: 'cervelo-s5', name: 'Cervélo S5', gap: 18, time: '2:44:02' },
    { id: 'tarmac-sl8', name: 'Tarmac SL8', gap: 28, time: '2:44:12' },
    { id: 'colnago-y1rs', name: 'Colnago Y1Rs', gap: 34, time: '2:44:18' },
    { id: 'factor-one', name: 'Factor One', gap: 63, time: '2:44:47' }
]
